import { useT } from '../lib/i18n';
import { useSeo } from '../lib/seo';
import { ButtonLink, Ornament } from '../components/ui';

export function NotFoundPage({ title }: { title?: string }) {
  const t = useT();
  useSeo({ title: t.notFound.seo, noindex: true });
  return (
    <div className="container-page flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
      <p className="font-display text-[7rem] leading-none font-bold text-oat md:text-[10rem]">404</p>
      <h1 className="font-display mt-4 text-3xl font-semibold md:text-4xl">{title ?? t.notFound.title}</h1>
      <Ornament className="mt-6" />
      <p className="mt-5 max-w-md text-stone italic">{t.notFound.body}</p>
      <div className="mt-9 flex gap-3">
        <ButtonLink to="/">{t.common.shopAll}</ButtonLink>
        <ButtonLink to="/" variant="secondary">
          {t.common.home}
        </ButtonLink>
      </div>
    </div>
  );
}
